import React, { useState,useEffect } from 'react';
import processService from '../../services/process.service';
import {toast} from 'react-toastify'
import {Link} from 'react-router-dom'
import Pagination2 from './Pagination2';
const SmsProcessTable = () => {

  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedItems, setSelectedItems] = useState([]);
  const [data,setData] = useState(null)
  const [currentItems,setCurrentItems] = useState([])
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);
 const [pageNumbers,setPageNumbers] = useState([])
 const [totalPages,setTotalPages] = useState()

  useEffect(()=>{
    getList(currentPage,itemsPerPage)
  },[currentPage,itemsPerPage])

  const getList = (pageNo,pageSize)=>{
    
    processService.getAllSmsQueue(pageNo,pageSize)
    .then(res=>{
        console.log(res)
        setData(res.data)
        setCurrentItems(res.data.content)
        let pgNo = []
        for ( let i =1 ; i<= res.data.totalPages;i++){
          pgNo.push(i)
        }
        setPageNumbers(pgNo)
        setTotalPages(res.data.totalPages)
    })
    .catch(err=>{
        console.log(err)
    })
  }
  const toggleRow = (rowIndex) => {
    if (expandedRowIndex === rowIndex) {
      setExpandedRowIndex(null);
    } else {
      setExpandedRowIndex(rowIndex);
    }
  };

  const handleCheckboxChange = (event, item) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedItems([...selectedItems, item]);
    } else {
      setSelectedItems(selectedItems.filter(selectedItem => selectedItem.id !== item.id));
    }
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value));
    setCurrentPage(0); // Reset to the first page when changing items per page
  };

 

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
 const handleDelete = ()=>{
    if(selectedItems.length > 0){
      let arrItem = selectedItems.map((item)=>(item.id))
      processService.deleteSmsQueue(arrItem)
      .then(res=>{
        toast.success("Items Deleted",{
          position:toast.POSITION.BOTTOM_RIGHT
        })
        getList(1,itemsPerPage)
      })
      .catch(err=>{
        console.log(err)
        toast.error("Error while Deleting",{
          position:toast.POSITION.BOTTOM_RIGHT
        })
      })
    }
 }

 const StatusText = (st)=>{

    if(st === 0) return <span className='badge text-bg-info'>Waiting</span>
    if(st === 1) return <span className='badge text-bg-secondary'>Queue</span>
    if(st === 2) return <span className='badge text-bg-warning'>Resend</span>
    if(st === 3) return <span className='badge text-bg-success'>Sent</span> 
    if(st === 4) return <span className='badge text-bg-danger'>Failed</span>
   
    return <span className='badge text-bg-warning'>Unknown</span>
 }
 function toProperCase(inputString) {
  // Split the string into words based on underscores
  let words = inputString.split('_');

  // Capitalize the first letter of each word and join them back
  let properCaseString = words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');

  return properCaseString;
}
  return (
    <div className='p-2'>
      <div className="d-flex justify-content-between mb-3">
        <div className='d-flex flex-columns align-items-center'>
        <div className='form-group me-2'>
           <select id="itemsPerPage" className="form-select" value={itemsPerPage} onChange={handleItemsPerPageChange}>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="150">150</option>
            <option value="200">200</option>
            {/* Add more options as needed */}
          </select>
        </div>
       
        {selectedItems.length>0?<> <button className="btn btn-warning btn-sm me-2" onClick={handleDelete}>Delete Selected</button>  {selectedItems.length} Process Selected</>:""}
        </div>
       
        <nav>
        <Pagination2 currentPage={currentPage} totalPages={totalPages} onPageChange={paginate} />
        </nav>
        
      </div>
      <table className="table">
        <thead>
          <tr>
            <th></th>
            <th>ID</th>
            <th>Category</th>
            <th>Name</th>
            <th>Clinic Id</th>
            <th>Receiver</th>
            <th>Status</th>
            <th>Sent</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((item, index) => (
             <React.Fragment key={index}>
            <tr key={index}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedItems.some(selectedItem => selectedItem.id === item.id)}
                  onChange={(event) => handleCheckboxChange(event, item)}
                />
              </td>
              <td><small>{item.id}</small></td>
              <td><span><small>{toProperCase(item.category) }</small></span></td>
              <td><small>{item.patientName}</small></td>
              <td><small><Link target='_blank' to={'/clinics/'+item.clinicId}>{item.clinicId}</Link></small></td>
              <td><small>{item.receiver}</small></td>
              <td>{StatusText(item.status)}</td>
              <td><small>{item.dateSend} {item.timeSend}</small></td>
              <td>
                  <button className='btn btn-secondary btn-sm rounded' onClick={() => toggleRow(index)}>
                      {expandedRowIndex === index ? '-' : '+'}
                    </button>
              </td>
            </tr>
            {expandedRowIndex === index && (
              <tr>
                <td></td>
                <td></td>
                <td colSpan="6">
                <div className="collapse show p-3 rounded" style={{backgroundColor:"#e9ecef"}}>
                    <div className="d-flex justify-content-between align-items-center">

                    
                      <div className='d-flex flex-column'>
                        <span><small>Patient Id : {item.patientId}</small></span>
                        <span><small>Reminder Type : {item.reminderType}</small></span>
                        <span><small>Sender : {item.sender}</small></span>
                      
                        <span><small>Content : {item.smsContent}</small></span>
                        <span><small>Priority : {item.priority}</small></span>
                        <span><small>Extra Info : {item.extraInfo}</small></span>
                        <span><small>Plivo Message UUID : {item.plivoMessageUUID}</small></span>
                        <span><small>Created At : {item.createdAt}</small></span>
                        <span><small>Modified At : {item.modifiedAt}</small></span>
                      </div>

                      <div className="">
                         
                      </div>

                    </div>
                   
                  </div>
                </td>
              </tr>
            )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      <nav>
        <Pagination2 currentPage={currentPage} totalPages={totalPages} onPageChange={paginate} />
        </nav>
    </div>
  );
};

export default SmsProcessTable;
